import { createStore } from '@stencil/store';
import { number } from "joi";

const { state } = createStore({
  website: {},
  browser: {},
  auth: {},
  Router: {},
  productComparison: {},
    shop: {
    Basket: [],
    BasketTotal: number,
    BasketLimitExceeded: false,
    Shipping: number,
    ShippingLabel: "DPD tracked (1-2 business days)",
    ShippingAddress: {},
    Discount: 0,
    DiscountCode: '',
    DiscountDesc: "",
    DiscountPerc: 0.00,
    VAT: number,
    Total: number,
    Currency: "£",
    Enabled: false,
  },
});

// onChange('clicks', value => {
//   state.squaredClicks = value ** 2;
// });

export default state;
